import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { COLORS } from '../../styles/theme'
import { SvgIcon } from '../shared/SvgIcon'
import { SvgType } from '../shared/SvgIcon/SvgIcon'
import { AuditoriumQuestionCard } from './AuditoriumQuestionCard'
import { Page } from './styled'

export interface MessageType {
  show: boolean
  featured: boolean
  archived: boolean
  dbUser: string
  dbMessage: string
  dbTimestamp: string
}

export const LiveQuestions = ({ currentUser, handleSubmitMessage, messages, messagesLoading, submitLoading }) => {
  const [chat, setChat] = useState('')
  const [showQuestions, setShowQuestions] = useState([])
  const [pinned, setPinned] = useState({})
  const chatContainerRef = useRef(null)

  const scrollToBottom = () => {
    chatContainerRef.current.scrollTop = 9999999
  }

  useEffect(() => {
    if (messages) {
      const show = messages.filter((ques) => ques.show && !ques.featured)
      const featured = messages.filter((ques) => ques.featured)
      setShowQuestions(show)
      setPinned(featured.length > 0 ? featured[0] : {})
    }
  }, [messages])

  useEffect(() => {
    console.log(messagesLoading, chatContainerRef)
    if (!messagesLoading) {
      scrollToBottom()
    }
  }, [messagesLoading])

  const onQuestionInput = (e) => {
    setChat(e.target.value)
  }

  const handleQuestion = (e) => {
    e.preventDefault()
    toast('Thank you for submitting your question. Your question is now being reviewed.')
    handleSubmitMessage(chat, currentUser)
    setChat('')
  }

  return (
    <Page>
      <div className="card-container">
        <div className="messages" ref={chatContainerRef}>
          {messagesLoading ? <p className="text-center text-white">Loading...</p> : ''}
          {showQuestions.length === 0 ? (
            <div className="helptext">
              <h6>
                Thank you for submitting question we will try our best to answer your question or your respective agency directors will be reaching out to you
                after the event.
              </h6>
            </div>
          ) : (
            [pinned, ...showQuestions].map((message, index) => message?.show && <AuditoriumQuestionCard key={index} message={message} />)
          )}
        </div>
      </div>
      <form id="chat-form" onSubmit={handleQuestion}>
        <input type="text" value={chat} onChange={onQuestionInput} className="form-input" placeholder="Type your question here..." />
        <button className="btn" type="submit" disabled={submitLoading || !chat.length}>
          <span>Submit Question</span>
          <SvgIcon type={SvgType.SUBMIT} fill={COLORS.primary} />
        </button>
      </form>
    </Page>
  )
}
